module.exports = __webpack_public_path__ + "static/img/5-1.86af0ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/presscenter/5-1.png
// module id = yU93
// module chunks = 15